(function() {
  'use strict';

  angular.module('component.emailTemplates', []);
})();
